import { Link } from "react-router-dom"
import styles from "./index.module.less"
import { useLocation } from "react-router-dom"
import store from "@/store"

function Menus() {
  const state = store.getState()
  const currentPath = useLocation().pathname
  const easyLiao = () => {
    window.openJesongChatByGroup(121, 52601)
    return false
  }
  const regionId = state.region.checked._id
  function DropList(props) {
    return (
      <li className={styles["drop-wrap"]}>
        <a onClick={() => false}>{props.name}</a>
        <ul className={styles["drop-list"]}>
          {["初三", "高一", "高二", "高三"].map((grade) => {
            return (
              <li className={styles["drop-option"]} key={grade}>
                <a onClick={easyLiao}>{grade}</a>
              </li>
            )
          })}
        </ul>
      </li>
    )
  }
  return (
    <ul className={styles["nav-menus"]}>
      <li>
        <Link
          to={`/${regionId ? "?regionId=" + regionId : ""}`}
          className={currentPath === "/" ? styles.current : ""}
        >
          首页
        </Link>
      </li>
      <DropList name="普通高考" />
      <DropList name="职普融通" />
      <DropList name="职教高考" />
      <DropList name="艺考升学" />
      <DropList name="单招培训" />
      <li>
        <Link
          to={`/college${regionId ? "?regionId=" + regionId : ""}`}
          className={currentPath.includes("/college") ? styles.current : ""}
        >
          中职院校
        </Link>
      </li>
      <DropList name="学大职教" />
      {/* <li>
        <Link to="/college">合作院校</Link>
      </li>
      <li>
        <Link to="/classtype">班型介绍</Link>
      </li>
      <li>
        <Link to="/information">热点资讯</Link>
      </li> */}
    </ul>
  )
}

export default Menus
